import classNames from 'classnames'
import * as React from 'react'
import { Line as RechartsLine } from 'recharts'

import { LineDot } from './LineDot'
import { CHART_ITEM_COLORS, ChartItemColorType } from './constants'

interface LineProps extends React.PropsWithoutRef<React.ComponentProps<typeof RechartsLine>> {
  color?: ChartItemColorType
}

export class Line extends React.Component<LineProps> {
  static getComposedData = RechartsLine.getComposedData
  static displayName = RechartsLine.displayName

  static defaultProps = {
    ...RechartsLine.defaultProps,
    type: 'linear',
    // Intentionally set to empty string to override defaults
    dot: <LineDot className="" />,
    activeDot: false,
    isAnimationActive: false,
    connectNulls: false,
    stroke: null,
  }

  render() {
    const { color = 'blue', ...props } = this.props
    return (
      <RechartsLine
        {...props}
        stroke={null as any}
        className={classNames(props.className, 'fill-current stroke-current', CHART_ITEM_COLORS[color])}
      />
    )
  }
}
